import { Request, Get, Post, Put } from '@navent-jobs/config'

export class ErrorAutopostulacion extends Error {}

class Autopostulacion {
  public esBlueCollar = () => {
    const request = new Request()
    request.path = `/api/autopostulacion/esBlueCollar`
    request.method = Post
    return request
      .call()
      .then(response => {
        return response
      })
      .catch(() => {
        throw new ErrorAutopostulacion(`Error al obtener perfil blue collar`)
      })
  }

  public suscriptoAutopostulacion = () => {
    const request = new Request()
    request.path = `/api/autopostulacion/suscripto`
    request.method = Get
    return request
      .call()
      .then(response => {
        return response
      })
      .catch(() => {
        throw new ErrorAutopostulacion(`Error al obtener suscripcion de autopostulacion`)
      })
  }

  public suscribirAutopostulacion = suscribir => {
    const request = new Request()
    request.path = `/api/autopostulacion/suscripcion?suscribir=${suscribir}`
    request.method = Put
    return request
      .call()
      .then(response => {
        return response
      })
      .catch(() => {
        throw new ErrorAutopostulacion(`Error al suscribir a autopostulacion`)
      })
  }
}

const autopostulacion = new Autopostulacion()
export default autopostulacion
